import configs from 'configs';

import WelcomePage from 'containers/WelcomePage/Loadable';
import FaqPage from 'containers/FaqPage/Loadable';
import SupportPage from 'containers/SupportPage/Loadable';
import Dashboard from 'containers/Dashboard/Loadable';
import OffersPage from 'containers/Offers/';
import OfferPage from 'containers/Offer/Loadable';
import RequestOfferPage from 'containers/RequestOffer/Loadable';
import QuotationsPage from 'containers/Quotations/Loadable';
import QuotationPage from 'containers/Quotation/Loadable';

import AdminPage from 'containers/Admin/Loadable';
import AgentQuotationsPage from 'containers/AgentQuotations/Loadable';

import MarketingPage from 'containers/Marketing/Loadable';

import CustomersPage from 'containers/Customers/Loadable';
import CustomerPage from 'containers/Customer/Loadable';

import CatalogAddPage from 'containers/CatalogAdd/Loadable';
import CatalogEditPage from 'containers/CatalogEdit/Loadable';
import CatalogShowPage from 'containers/CatalogShow/Loadable';

import ProvidersList from 'containers/ProvidersList/Loadable';
import ProviderAdd from 'containers/ProviderAdd/Loadable';
import ProviderEdit from 'containers/ProviderEdit/Loadable';

import ProductsList from 'containers/ProductsList/Loadable';
import ProductAdd from 'containers/ProductAdd/Loadable';
import ProductEdit from 'containers/ProductEdit/Loadable';

import ProfilePage from 'containers/Profile/Loadable';

const routes = [
  {
    path: '/',
    name: 'Home',
    icon: 'os-icon os-icon-ui-55',
    component: WelcomePage,
    role: 0,
    show: true,
  },
  {
    path: '/offers',
    name: 'Offerte',
    icon: 'os-icon os-icon-cv-2',
    component: OffersPage,
    role: 0,
    show: true,
  },
  {
    path: '/offers/:offer',
    component: OfferPage,
    show: false,
  },
  {
    path: '/offer/request',
    component: RequestOfferPage,
    show: false,
    feature: 'offer-request',
  },
  {
    path: '/quotations',
    name: 'Preventivi Salvati',
    icon: 'os-icon os-icon-phone-21',
    component: QuotationsPage,
    role: 0,
    show: true,
  },
  {
    path: '/quotation/',
    component: QuotationPage,
    show: false,
  },
  {
    path: '/quotations/:quotation',
    component: QuotationPage,
    hasFaqSalesBot: false,
    show: false,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: 'os-icon os-icon-layout',
    component: Dashboard,
    role: 0,
    show: true,
  },
  {
    path: '/agents/:agent',
    component: AgentQuotationsPage,
    show: false,
  },
  {
    path: '/admin',
    name: 'Rete',
    icon: 'os-icon os-icon-hierarchy-structure-2',
    component: AdminPage,
    role: 1,
    show: true,
    feature: 'network',
  },
  {
    path: '/catalog',
    name: 'Catalogo',
    icon: 'os-icon os-icon-package',
    component: CatalogShowPage,
    role: 0,
    show: true,
    feature: 'catalog',
  },
  {
    path: '/catalog/new',
    component: CatalogAddPage,
    show: false,
  },
  {
    path: '/catalog/:offer/edit',
    component: CatalogEditPage,
    show: false,
  },
  {
    path: '/providers',
    name: 'Provider',
    icon: 'os-icon os-icon-grid-squares2',
    component: ProvidersList,
    role: 0,
    show: true,
    feature: 'provider-product',
  },
  {
    path: '/providers/new',
    component: ProviderAdd,
    show: false,
  },
  {
    path: '/providers/:provider/edit',
    component: ProviderEdit,
    show: false,
  },
  {
    path: '/products',
    name: 'Prodotti',
    icon: 'os-icon os-icon-ui-44',
    component: ProductsList,
    role: 0,
    show: true,
    feature: 'provider-product',
  },
  {
    path: '/products/new',
    component: ProductAdd,
    show: false,
  },
  {
    path: '/products/:product/edit',
    component: ProductEdit,
    show: false,
  },
  {
    path: '/customers',
    component: CustomersPage,
    show: false,
  },
  {
    path: '/customers/:customer',
    component: CustomerPage,
    show: false,
  },
  {
    path: '/profile',
    component: ProfilePage,
    show: false,
  },
  {
    path: '/marketing',
    name: 'Materiale pubblicitario',
    icon: 'os-icon os-icon-window-content',
    component: MarketingPage,
    role: 0,
    show: configs.marketingSection,
    feature: 'marketing-stuff',
  },
  {
    path: '/faq',
    name: 'Domande Frequenti',
    icon: 'os-icon os-icon-robot-1',
    component: FaqPage,
    role: 0,
    show: true,
  },
  {
    path: '/support',
    name: 'Supporto',
    icon: 'os-icon os-icon-mail-01',
    component: SupportPage,
    role: 0,
    show: true,
    feature: 'support',
  },
  // { redirect: true, path: '/', to: '/', name: 'Dashboard' },
];

export default routes;
